module.exports = __webpack_public_path__ + "static/img/ys.0310be8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Virus/Adeno/ys.png
// module id = q65G
// module chunks = 16